import Header from "./Header";
import BgPattern from "./BgPattern";

type ContainerProps = {
    id?: string;
    className?: string;
    headerLeft?: React.ReactNode;
    hideFooter?: boolean;
    children: React.ReactNode;
};

const Container = ({ id, className = "", headerLeft, hideFooter, children }: ContainerProps) => (
    <div id={id} data-tooltip-container className={`w-full select-none relative isolate safe-area-container ${hideFooter ? "overflow-hidden" : ""} ${className}`}>
        <BgPattern />
        <div className="container-inner relative z-10 lg:max-w-7xl mx-auto w-full px-4">
            <Header>
                {headerLeft}
            </Header>

            {children}

        </div>
    </div>
);

export default Container;
